import {ONE_MINUTE_MS, useServerTime} from '@glark-newco/game-library';
import {Container, Sprite, Text} from '@pixi/react';
import {Dayjs} from 'dayjs';
import {Assets} from 'pixi.js';
import {PropsWithChildren} from 'react';
import {LCD_FONT, TIME_PANEL} from '../assetManifest';
import {textStyle} from '../constants';
import {useAllObjectivesComplete} from '../hooks/useObjectivesComplete';
import {useGameEndTime} from '../state/GameTimerSlice';

const FIVE_MINUTES_MS = ONE_MINUTE_MS * 5;

function NumericTime({currentTime}: {currentTime: Dayjs}) {

    const lcdFont = Assets.get<FontFace>(LCD_FONT).family;
    const fontColour = currentTime.valueOf() > FIVE_MINUTES_MS ? '#5fba00' : '#ff0000';
    return (
        <Text
            x={25} y={22}
            text={currentTime.valueOf() > 0 ? currentTime.format('mm:ss') : '00:00'}
            style={textStyle({
                fontFamily: lcdFont, fontSize: 44,
                fontWeight:'normal',
                fill: [fontColour],
                stroke: fontColour,
            })}
        />
    );
}

const NumericServerTime = () => {
    const currentTime = useServerTime();
    const gameEndTime = useGameEndTime();
    const objectivesComplete = useAllObjectivesComplete();

    if (!gameEndTime || objectivesComplete)
        return <></>;

    // console.debug(`TimePanel gameEndTime:${gameEndTime?.toISOString()}, currentTime:${currentTime.toString()}`);

    return (
        <>
            <NumericTime currentTime={gameEndTime ? gameEndTime.subtract(currentTime.valueOf()) : currentTime }/>
        </>
    );
};

interface TimePanelProps extends PropsWithChildren {
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function TimePanel(_props: TimePanelProps) {
    return (
        <Container
            x={1510} y={5}
            width={200} height={100}
        >
            <Sprite
                texture={Assets.get(TIME_PANEL)}
                width={200} height={100}
                x={0} y={0}
                eventMode={'static'}/>
            <NumericServerTime/>
        </Container>
    );
}